import React from 'react';
import Icon from './Icon';

export default function BigBulletList({ items, bulletColor, className }) {
  return (
    <div
      className={`big-bullet-list bullet-color-${bulletColor} ${
        items.length <= 3 ? 'small' : 'large'
      } ${className || ''}`}
    >
      <ul>
        {items.map((item, index) => (
          <li key={index} className="big-bullet-list-item-container">
            <Icon icon="circle" size="lg" className="bullet-icon" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
